"use client";

import React, { useRef, useState } from "react";

import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
  ModalHeader,
} from "reactstrap";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useDispatch, useSelector } from "react-redux";
import AddRoomRate from "./Global/AddRoomRate";
import TablelRates from "./Global/TablelRates";
import { deleteRates } from "../../store/roomsrates/actions";

const RoomsRates = () => {
  //   const [modal_list, setmodal_list] = useState(false);
  const [modal_center, setmodal_center] = useState(false);
  const [modal_export, setmodal_export] = useState(false);
  //   const [files, setFiles] = React.useState(null);
  //   const [base64Image, setBase64Image] = useState("");
  const [editItem, setEditItem] = React.useState({});
  const [filteredData, setFilteredData] = useState([]);
  const [viewImagesModal, setViewImagesModal] = useState(false);
  const [currentImages, setCurrentImages] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const [checkedItems, setCheckedItems] = useState([]);

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;

    // If the checkbox is checked, add the value to the array
    if (checked) {
      setCheckedItems((prevState) => [...prevState, value]);
    } else {
      // If the checkbox is unchecked, remove the value from the array
      setCheckedItems((prevState) =>
        prevState.filter((item) => item !== value)
      );
    }
  };

  const state = useSelector((state) => state);

  const dispatch = useDispatch();

  const fileInputRef = useRef(null);

  document.title = "Rooms Rates | Rosa";

  function tog_center() {
    setmodal_center(!modal_center);
    setEditItem({});
  }

  function tog_export() {
    setmodal_export(!modal_export);
  }

  const handleEdit = (item) => {
    setEditItem(item);
    setmodal_center(!modal_center);
  };

  const handleDelete = (itemId) => {
    dispatch(deleteRates({ id: itemId }));
  };

  // Update the handleViewImages function to correctly use the image objects from the API
  const handleViewImages = (item) => {
    if (item.images && item.images.length > 0) {
      // Use the actual image URLs from the API response
      const imageUrls = item.images.map((image) => image.url);

      console.log("Viewing images for room:", item.roomtype);
      console.log("Image URLs:", imageUrls);

      setCurrentImages(imageUrls);
      setCurrentImageIndex(0);
      setViewImagesModal(true);
    }
  };

  const handleNextImage = () => {
    if (currentImageIndex < currentImages.length - 1) {
      setCurrentImageIndex(currentImageIndex + 1);
    }
  };

  const handlePrevImage = () => {
    if (currentImageIndex > 0) {
      setCurrentImageIndex(currentImageIndex - 1);
    }
  };

  const handleSearch = (text) => {
    const newQuery = text.target.value;

    const filtered = state.Rates.Rates.filter(
      (roomtype) => roomtype.roomtype == newQuery
    );
    setFilteredData(filtered);
  };

  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = state.Rates.Rates.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  // const currentItems = [];
  const totalPages = Math.ceil(state.Rates.Rates.length / itemsPerPage);

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const setPage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const getPageNumbers = () => {
    const pageNumbers = [];
    const maxPageNumbers = 10;
    const maxVisiblePages = Math.min(totalPages, maxPageNumbers);

    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage < maxVisiblePages - 1) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return pageNumbers;
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Rosa" breadcrumbItem="Rooms Rates" />

          <Row>
            <Col lg={12}>
              <Card>
                {/* <CardHeader>
                  <h4 className="card-title mb-0">Add, Edit & Remove</h4>
                </CardHeader> */}

                <CardBody>
                  <div id="customerList">
                    <Row className="g-4 mb-3">
                      <Col className="col-sm-auto">
                        <div className="d-flex gap-1">
                          <Button
                            color="success"
                            className="add-btn"
                            onClick={() => tog_center()}
                            id="create-btn"
                          >
                            <i className="ri-add-line align-bottom me-1"></i>{" "}
                            Add Room Rate
                          </Button>
                        </div>
                      </Col>
                      <Col className="col-sm">
                        <div className="d-flex justify-content-sm-end">
                          <div className="search-box ms-2">
                            <input
                              type="text"
                              className="form-control search"
                              placeholder="Search..."
                              onChange={(e) => handleSearch(e)}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>

                    <div className="table-responsive table-card mt-3 mb-1">
                      <table
                        className="table align-middle table-nowrap"
                        id="customerTable"
                      >
                        <thead className="table-light">
                          <tr>
                            {/* <th scope="col" style={{ width: "50px" }}>
                              {/* <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="checkAll"
                                  value="option"
                                />
                              </div>
                            </th> */}
                            <th className="sort" data-sort="customer_name">
                              Room type
                            </th>
                            <th className="sort" data-sort="customer_name">
                              Room floor
                            </th>
                            <th className="sort" data-sort="customer_name">
                              SYP (SGL)
                            </th>
                            <th className="sort" data-sort="customer_name">
                              USD (SGL)
                            </th>
                            <th className="sort" data-sort="customer_name">
                              Images
                            </th>
                            <th className="sort" data-sort="action">
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody className="list form-check-all">
                          {filteredData.length === 0
                            ? currentItems.map((rate) => (
                                <TablelRates
                                  key={rate.id}
                                  rate={rate}
                                  handleEdit={handleEdit}
                                  handleDelete={handleDelete}
                                  handleCheckboxChange={handleCheckboxChange}
                                  checkedItems={checkedItems}
                                  handleViewImages={handleViewImages}
                                />
                              ))
                            : filteredData.map((rate) => (
                                <TablelRates
                                  key={rate.id}
                                  rate={rate}
                                  handleEdit={handleEdit}
                                  handleDelete={handleDelete}
                                  handleCheckboxChange={handleCheckboxChange}
                                  checkedItems={checkedItems}
                                  handleViewImages={handleViewImages}
                                />
                              ))}
                        </tbody>
                      </table>
                      <div className="noresult" style={{ display: "none" }}>
                        <div className="text-center">
                          <lord-icon
                            src="https://cdn.lordicon.com/msoeawqm.json"
                            trigger="loop"
                            colors="primary:#121331,secondary:#08a88a"
                            style={{ width: "75px", height: "75px" }}
                          ></lord-icon>
                          <h5 className="mt-2">Sorry! No Result Found</h5>
                          <p className="text-muted mb-0">
                            We've searched more than 150+ Orders We did not find
                            any orders for you search.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="d-flex justify-content-center">
                      <div className="pagination-wrap hstack gap-2">
                        <div className="d-flex justify-content-end">
                          <div
                            className="btn-group me-2"
                            role="group"
                            aria-label="First group"
                          >
                            <button
                              className="page-item pagination-prev btn btn-primary"
                              onClick={prevPage}
                              type="button"
                              disabled={currentPage === 1}
                            >
                              Previous
                            </button>
                            {getPageNumbers().map((pageNumber) => (
                              <button
                                type="button"
                                className="btn btn-primary"
                                key={pageNumber}
                                disabled={pageNumber === currentPage}
                                onClick={() => setPage(pageNumber)}
                              >
                                {pageNumber}
                              </button>
                            ))}
                            <button
                              disabled={currentPage === totalPages}
                              className="page-item pagination-prev btn btn-primary"
                              type="button"
                              onClick={nextPage}
                            >
                              Next
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {modal_center ? (
            <AddRoomRate
              modal_center={modal_center}
              setmodal_center={setmodal_center}
              tog_center={tog_center}
              data={editItem}
            />
          ) : null}

          {/* Image Viewer Modal */}
          <Modal
            isOpen={viewImagesModal}
            toggle={() => setViewImagesModal(!viewImagesModal)}
            size="lg"
            centered
          >
            <ModalHeader toggle={() => setViewImagesModal(!viewImagesModal)}>
              Room Images ({currentImageIndex + 1}/{currentImages.length})
            </ModalHeader>
            <ModalBody className="p-0">
              <div className="position-relative">
                {currentImages.length > 0 && (
                  <img
                    src={currentImages[currentImageIndex] || "/placeholder.svg"}
                    alt={`Room image ${currentImageIndex + 1}`}
                    className="img-fluid w-100"
                    style={{ maxHeight: "70vh", objectFit: "contain" }}
                  />
                )}

                {/* Navigation arrows */}
                <div
                  className="d-flex justify-content-between position-absolute w-100"
                  style={{ top: "50%" }}
                >
                  {currentImageIndex > 0 && (
                    <Button
                      color="light"
                      className="rounded-circle p-2 shadow"
                      onClick={handlePrevImage}
                      style={{ marginLeft: "10px" }}
                    >
                      <i className="ri-arrow-left-line fs-4"></i>
                    </Button>
                  )}

                  {currentImageIndex < currentImages.length - 1 && (
                    <Button
                      color="light"
                      className="rounded-circle p-2 shadow"
                      onClick={handleNextImage}
                      style={{ marginRight: "10px" }}
                    >
                      <i className="ri-arrow-right-line fs-4"></i>
                    </Button>
                  )}
                </div>
              </div>

              {/* Thumbnails */}
              <div className="d-flex overflow-auto p-3 bg-light">
                {currentImages.map((img, idx) => (
                  <div
                    key={idx}
                    className={`thumbnail-container mx-1 ${
                      idx === currentImageIndex ? "border border-primary" : ""
                    }`}
                    style={{ cursor: "pointer" }}
                    onClick={() => setCurrentImageIndex(idx)}
                  >
                    <img
                      src={img || "/placeholder.svg"}
                      alt={`Thumbnail ${idx + 1}`}
                      style={{
                        width: "60px",
                        height: "60px",
                        objectFit: "cover",
                        opacity: idx === currentImageIndex ? 1 : 0.6,
                      }}
                    />
                  </div>
                ))}
              </div>
            </ModalBody>
            <ModalFooter>
              <Button
                color="secondary"
                onClick={() => setViewImagesModal(false)}
              >
                Close
              </Button>
            </ModalFooter>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default RoomsRates;
